<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in errors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Reciept No."
          v-model="id"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Name"
          v-model="name"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          type="date"
          label="Date Of Reciept"
          v-model="dateOfReciept"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          type="date"
          label="Due Date"
          v-model="dateDue"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          dark
          :loading="storing"
          @click="update"
        >Save</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { errorHandler } from '@/extra-functions/store.extra'
  import consumerLoanRepository from '@/repositories/consumer-loan.repository'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  const typing = searchDelay(300)
  export default {
    name: 'create-consumer-loan',
    props: {
      propConsumerLoan: Object,
      propConsumerId: String,
    },
    data () {
      return {
        id: null,
        name: null,
        dateOfReciept: null,
        errors: [],
        storing: false,
        dateDue: null,
      }
    },
    watch: {
      propConsumerLoan (consumerLoan) {
        this.id = consumerLoan.id
        this.name = consumerLoan.loanee_name
        this.dateOfReciept = consumerLoan.date_loaned
        this.dateDue = consumerLoan.date_due
      },
      crNumber (val) {
        const regX = /\s/ig
        if (regX.test(val)) {
          typing(() => {
            this.crNumber = val.replace(regX, '')
          })
        }
      },
    },
    methods: {
      update () {
        if (!this.storing) {
          this.storing = true
          this.errors = []
          const id = this.propConsumerLoan.id
          const consumer = this.propConsumerId
          const data = {
            id: this.id,
            loanee_name: this.name,
            date_loaned: this.dateOfReciept,
            date_due: this.dateDue,
          }
          consumerLoanRepository.update(consumer, { id, data })
            .then(() => { })
            .catch(errors => { this.errors = errorHandler(errors) })
            .then(() => { this.storing = false })
        }
      },
      clearInputs () {
        this.name = null
        this.date = null
      },
    },
  }
</script>
